// extracted by mini-css-extract-plugin
export default {"tabMenu":"TabMenuCrm_tabMenu__ncnME","tabs":"TabMenuCrm_tabs__U-E3p","tab":"TabMenuCrm_tab__P1efE","active":"TabMenuCrm_active__+IWnF","count":"TabMenuCrm_count__mxo-6"};